/**
 * 系统用户接口列表
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const orderAlone = {
    //创建订单（独立版）
    createOrderAlone(params) {
        const userLevelId = localStorage.getItem('userLevelId') || ''
        params.userLevelId = userLevelId
        return axios.post('/order/mobileOrderAlone/createOrderAlone', params);
    },
    //获取用户中心数据（独立版）
    getUserCenterAlone(params) {
        return axios.post('/goods/mobileUserAlone/getUserCenterAlone', qs.stringify(params));
    },
    //获取客户订单列表信息
    getUserAllOrderAloneInfo(params) {
        return axios.post('/order/mobileOrderAlone/getUserAllOrderAloneInfo', qs.stringify(params));
    },
    //手机前台获取客户订单详情信息（独立版）
    getUserOrderDetailAloneInfo(params) {
        return axios.post('/order/mobileOrderAlone/getUserOrderDetailAloneInfo', qs.stringify(params));
    },
    //校验客户下单规则
    checkOrderRule(params) {
        return axios.post('/order/mobileOrderAlone/checkOrderRule', qs.stringify(params));
    },
    //作废订单信息
    cancelOrderInfoAlone(params) {
        return axios.post('/order/mobileOrderAlone/cancelOrderInfoAlone', qs.stringify(params));
    },
    //取消订单信息
    delOrderInfoAlone(params) {
        return axios.post('/order/mobileOrderAlone/delOrderInfoAlone', qs.stringify(params));
    },
    //上传图片
    uploadGoodsImgAlone(params) {
        return axios.post('/order/revisionMobileOrderAlone/uploadGoodsImgAlone', qs.stringify(params));
    },
    //取消订单
    delOrderInfoAloneNew(params){
        return axios.post('/order/mobileOrderAlone/delOrderInfoAloneNew', qs.stringify(params));
    },
    //收货
    receivingNewMobile(params){
        return axios.post('/order/mobileOrderAlone/receivingNewMobile', qs.stringify(params));
    },
    //邮政预支付接口
    vprePay(params){
        return axios.post('/order/bankPay/vprePay', qs.stringify(params));
    },
    //储值支付接口
    storedPay(params){
        return axios.post('/order/sysConfig/storedPay', qs.stringify(params));
    },
    //再来一单（独立版）
    reorderGoodsInfo(params){
        return axios.post('/goods/mobileGoodsAlone/reorderGoodsInfo', qs.stringify(params));
    },
}

export default orderAlone;


// WEBPACK FOOTER //
// ./src/request/api/order/order_alone.js